import { useLocation, useParams } from "react-router-dom";
import { Pagination } from "antd";
import { useDispatch, useSelector } from "react-redux";
import {
  AppDispatch,
  dynamicSet,
  getChildOrganizationList,
  getChildOrganizationListRequest,
  getClientOrganizationList,
  getClientOrganizationListRequest,
  getDeviceList,
  getDeviceListRequest,
  getKitList,
  getKitListRequest,
  getUserRoleList,
  getUserRoleListRequest,
  getSubjectList,
  getSubjectListRequest,
  useDynamicSelector,
} from "@src/redux";
import { retrieveItem } from "@src/helpers/functions";

type Props = {};

const CommonPagination = (props: Props) => {
  const location = useLocation();
  const dispatch = useDispatch<AppDispatch>();
  const organizationId = retrieveItem("organizationId");
  const { id: parenOrganizationId } = useParams();

  const { result: clientResults } = useSelector(getClientOrganizationList);
  const { result: kitResult } = useSelector(getKitList);
  const { result: childOrganizationResult } = useSelector(
    getChildOrganizationList
  );
  const { result: userRoleResult } = useSelector(getUserRoleList);
  const { result: subjectResult } = useSelector(getSubjectList);
  const { result: deviceResult } = useSelector(getDeviceList);
  const { filter: clientFilter } = useDynamicSelector("client_filter");
  const { filter: subjectFilter } = useDynamicSelector("subject_filter");
  const { filter: deviceFilter } = useDynamicSelector("device_filter");
  const { filter: kitFilter } = useDynamicSelector("kit_filter");
  const { filter: roleFilter } = useDynamicSelector("role_filter");
  const { filter: organizationFilter } = useDynamicSelector(
    "organization_filter"
  );

  const handleChange = (page: number, pageSize: number) => {
    const pagination = {
      pageNumber: page || 1,
      pageLimit: pageSize || 10,
    };

    if (location.pathname.includes("devices")) {
      dispatch(dynamicSet("device_pagination", { pagination }));
      dispatch(
        getDeviceListRequest({ filter: { ...deviceFilter }, pagination })
      );
    } else if (location.pathname.includes("kits")) {
      dispatch(dynamicSet("kit_pagination", { pagination }));
      dispatch(
        getKitListRequest({
          filter: { ...kitFilter },
          pagination,
          sort: [{ field: "effectiveTill", order: "asc" }],
        })
      );
    } else if (location.pathname.includes("clients")) {
      dispatch(dynamicSet("client_pagination", { pagination }));
      dispatch(
        getClientOrganizationListRequest({
          filter: { ...clientFilter },
          pagination,
          sort: [{ field: "name", order: "asc" }],
        })
      );
    } else if (location.pathname.includes("org")) {
      dispatch(dynamicSet("organization_pagination", { pagination }));
      dispatch(
        getChildOrganizationListRequest({
          filter: {
            ...organizationFilter?.filter,
            parentOrganizationId: parenOrganizationId,
          },
          pagination,
          sort: [{ field: "name", order: "asc" }],
        })
      );
    } else if (location.pathname.includes("roles")) {
      dispatch(dynamicSet("role_pagination", { pagination }));
      dispatch(
        getUserRoleListRequest({
          filter: { ...roleFilter },
          pagination,
          sort: [{ field: "name", order: "asc" }],
        })
      );
    } else if (location.pathname.includes("subjects")) {
      dispatch(dynamicSet("subject_pagination", { pagination }));
      dispatch(
        getSubjectListRequest({ filter: { ...subjectFilter }, pagination })
      );
    }
  };

  const renderPagination = (result: any, path: string) => {
    const current = result?.pagination?.pageNumber || 1;
    const total = result?.pagination?.totalCount || result?.items?.length;
    const pageSize = result?.pagination?.pageLimit || 10;

    return (
      <Pagination
        current={current}
        pageSize={pageSize}
        total={total}
        onChange={handleChange}
        showSizeChanger={true}
        pageSizeOptions={[10, 20, 50, 100]}
      />
    );
  };

  if (location.pathname.includes("devices"))
    return renderPagination(deviceResult, "devices");
  if (location.pathname.includes("kits"))
    return renderPagination(kitResult, "kits");
  if (location.pathname.includes("clients"))
    return renderPagination(clientResults, "clients");
  if (location.pathname.includes("org"))
    return renderPagination(childOrganizationResult, "org");
  if (location.pathname.includes("roles"))
    return renderPagination(userRoleResult, "roles");
  if (location.pathname.includes("subjects"))
    return renderPagination(subjectResult, "subjects");

  return null;
};

export default CommonPagination;
